module.exports = __webpack_public_path__ + "static/media/sia-disadv-poor.a5e7419e.png";